import React from 'react';
import { motion } from 'framer-motion';
import { Clock, DollarSign, Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function TrustBar() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: Clock,
    title: t('trust.1.title'),
    desc: t('trust.1.desc')
  }, {
    icon: DollarSign,
    title: t('trust.2.title'),
    desc: t('trust.2.desc')
  }, {
    icon: Users,
    title: t('trust.3.title'),
    desc: t('trust.3.desc')
  }];
  return <section className="py-10 md:py-14 bg-white border-b border-[#f0f0f0]" data-id="element-199">
      <div className="container mx-auto px-5 md:px-6" data-id="element-200">
        <div className="grid grid-cols-3 gap-4 md:gap-12" data-id="element-201">
          {features.map((f, i) => <motion.div key={i} className="flex flex-col items-center text-center" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} data-id="element-202">
              <div className="w-11 h-11 md:w-14 md:h-14 bg-[#C41230]/10 rounded-full flex items-center justify-center mb-2.5 md:mb-4 text-[#C41230]" data-id="element-203">
                <f.icon className="w-5 h-5 md:w-7 md:h-7" data-id="element-204" />
              </div>
              <h3 className="text-xs md:text-base font-bold text-[#111111] uppercase tracking-tight leading-tight" data-id="element-205">
                {f.title}
              </h3>
              <p className="text-[#6b6b6b] text-[11px] md:text-sm mt-1 leading-snug hidden md:block" data-id="element-206">
                {f.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}